var map = {
	"./bartolini.svg": 66946,
	"./colli.svg": 53882,
	"./collo2.svg": 76337,
	"./dhl-1.svg": 43846,
	"./dhl.svg": 75461,
	"./fedex-express-6.svg": 13861,
	"./fedex.svg": 49142,
	"./gls.svg": 23774,
	"./label.svg": 59129,
	"./sda.svg": 65982,
	"./shippypro.svg": 72436,
	"./spediamo.svg": 26857,
	"./spedisciOnline.svg": 9760,
	"./tnt.svg": 84724,
	"./tracking.svg": 61718,
	"./tracking2.svg": 56683,
	"./tracking3.svg": 91994,
	"./tracking4.svg": 73693,
	"./ups (1).svg": 71261,
	"./ups.svg": 51589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2710;